safeGetBuiltIn